import { DocumentLink } from '@gasbi/shared/web/components';

import { PrimaryDocumentOwner } from '@/features/actsAndDocuments/primaryDocumentFiles';
import { DocumentFileModel } from '@/features/balanceActs/types';

import { List, ListItem, Typography } from '@mui/joy';

import { usePrimaryDocumentFileUrl } from '../hooks/usePrimaryDocumentFileUrl';

interface DocumentsListProps {
  documents: DocumentFileModel[] | null;
  // The primary document the documents belong to; their files are opened through it (GSB-8069).
  owner: PrimaryDocumentOwner;
}

export const DocumentsList = ({ documents, owner }: DocumentsListProps) => {
  const fileUrl = usePrimaryDocumentFileUrl(owner);

  // Only the documents that can be opened; none of them is the same as no documents.
  const links = (documents ?? []).flatMap(doc => {
    const url = fileUrl(doc.id);
    return doc.name && url ? [{ id: doc.id, name: doc.name, url }] : [];
  });

  if (!links.length) {
    return <Typography level='body-md'>Немає документів</Typography>;
  }

  return (
    <List
      orientation='horizontal'
      wrap
      sx={{
        '--ListItem-paddingLeft': '0',
        '--ListItem-paddingRight': '1.5rem',
      }}
    >
      {links.map(link => (
        <ListItem key={link.id}>
          <DocumentLink name={link.name} url={link.url} />
        </ListItem>
      ))}
    </List>
  );
};
